import { createFileRoute } from '@tanstack/react-router';

import { ErrorPage } from '@/components/errors';

export const Route = createFileRoute('/error/403')({
  component: ForbiddenError,
});

function ForbiddenError() {
  return (
    <ErrorPage
      status={403}
      message="You don't have permission to access this resource."
    />
  );
}
